export default "__VITE_ASSET__1m6nRLiJ__"